export function hyphenToUnderscore(text: string) {
  return text.replace(/-/g, '_')
}
